import http from './http.service';

class ActionLogService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/actionLog";
    }

    eventOpenForEdit(id) {
        return this.$http.post(`${this.baseUrl}/eventOpenForEdit`, { id: id });
    }

    eventCreate(id, data) {
        return this.$http.post(`${this.baseUrl}/eventCreate`, { id: id, data: JSON.stringify(data) });
    }

    eventUpdate(id, data) {
        return this.$http.post(`${this.baseUrl}/eventUpdate`, { id: id, data: JSON.stringify(data) });
    }

    eventDelete(id) {
        return this.$http.post(`${this.baseUrl}/eventDelete`, { id: id });
    }

    eventUnDelete(id) {
        return this.$http.post(`${this.baseUrl}/eventUnDelete`, { id: id });
    }

    eventArchive(id) {
        return this.$http.post(`${this.baseUrl}/eventArchive`, { id: id });
    }

    eventUnarchive(id) {
        return this.$http.post(`${this.baseUrl}/eventUnarchive`, { id: id });
    }

    userRolesChange(id) {
        return this.$http.post(`${this.baseUrl}/userRolesChange`, { idStr: id });
    }

    usersImport(data) {
        return this.$http.post(`${this.baseUrl}/usersImport`, { data: data });
    }

    personDetailsReview(id) {
        return this.$http.post(`${this.baseUrl}/personDetailsReview`, { id: id });
    }

    userManagementOpen(id, data) {
        return this.$http.post(`${this.baseUrl}/userManagementOpen`, { idStr: id, data: data });
    }

    registerSchemaOpenForEdit(id, isAuxiliary) {
        return this.$http.post(`${this.baseUrl}/registerSchemaOpenForEdit`, { id: id, condition: isAuxiliary });
    }

    formSchemaOpenForEdit(id) {
        return this.$http.post(`${this.baseUrl}/formSchemaOpenForEdit`, { id: id });
    }
}

export default new ActionLogService();
